import script from "./bonusProgramCard.vue?vue&type=script&setup=true&lang=js"
export * from "./bonusProgramCard.vue?vue&type=script&setup=true&lang=js"

import "./bonusProgramCard.vue?vue&type=style&index=0&id=e3af20aa&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3af20aa"]])

export default __exports__